import Swal from 'sweetalert2';

export const confirm = (config = {}) => {
    return Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: '#006fe2',
        cancelButtonColor: '#d52536',
        ...config
    });
}